export default {"src":"/_next/static/media/silver.5951193b.svg","height":103,"width":356,"blurWidth":0,"blurHeight":0};